import { render, staticRenderFns } from "./OPMView.vue?vue&type=template&id=0f86a11e&"
import script from "./OPMView.vue?vue&type=script&lang=js&"
export * from "./OPMView.vue?vue&type=script&lang=js&"
import style0 from "./OPMView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports